'use strict';

// Constructor
var TabBox = function () {
    $('.tab-box .switch button').click(function ($event) {
        $event.preventDefault();
        $(this).closest('.tab-box').find('.tab-container').removeClass('active');
        $(this).closest('.tab-box').find('.switch button').removeClass('active');
        $(this).closest('.tab-box').find('.' + $(this).data('target')).addClass('active');
        $(this).addClass('active');

        $(this).closest('.collapsible-box').addClass('expanded'); // Makes it easier to just click the tab and it expands the box
    });
};

module.exports = TabBox;
